import React, { useState, useEffect } from 'react';
import { AppointmentStepProps } from '../../navigators/AppointmentNavigator';
import { IonPage, IonContent, IonLoading, IonButton } from '@ionic/react';
import AppHeader from '../../components/AppHeader';
import Stepper from '../../components/Stepper';
import LaboratoryRepository from '../../repositories/LaboratoryRepository';
import { Appointment } from '../../models';
import { setAppointment } from '../../store/actions/appointments';
import { connect } from 'react-redux';

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  selectLaboratory: (appointment: Partial<Appointment>) =>
    dispatch(setAppointment(appointment))
});

const PreselectLaboratory: React.FC<
  AppointmentStepProps<{ slug: string }> & ReturnType<typeof mapDispatchToProps>
> = ({ step, match, history, nextStepRouterLink = '', selectLaboratory }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setisError] = useState(false);

  useEffect(() => {
    async function findLaboratory() {
      setIsLoading(true);
      const laboratory = await LaboratoryRepository.findBySlug(
        match.params.slug
      );

      if (
        laboratory &&
        laboratory.id &&
        laboratory.appointment_type !== 'none'
      ) {
        selectLaboratory({ laboratory: laboratory });
        history.replace(nextStepRouterLink);
      } else {
        setisError(true);
      }
      setIsLoading(false);
    }

    findLaboratory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPage>
      <AppHeader defaultBackLink="/" />
      <Stepper step={step} />
      <IonContent>
        <div className="wrapper">
          <div className="ion-padding">
            {isError ? (
              <div className="ion-text-center">
                <h1>Oups...</h1>
                <p>Aucun laboratoire ne correspond à cette adresse...</p>
                <IonButton routerLink="/">
                  Revenir à la page d'accueil
                </IonButton>
              </div>
            ) : null}
          </div>
        </div>
      </IonContent>
      <IonLoading isOpen={isLoading} />
    </IonPage>
  );
};

export default connect(null, mapDispatchToProps)(PreselectLaboratory);
